import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

import { camel } from 'change-case'

import account from './modules/account'
import aggregation from './modules/aggregation'
import common from './modules/common'
import company from './modules/company'
import companyTableConfiguration from './modules/company-table-configuration'
import corporation from './modules/corporation'
import corporationTableConfiguration from './modules/corporation-table-configuration'
import route from './modules/route'
import session from './modules/session'
import user from './modules/user'
import job from './modules/job'
import map from './modules/map'
import master from './modules/master'
import searchAggregation from './modules/searchAggregation'
import searchCompany from './modules/searchCompany'
import searchCorporation from './modules/searchCorporation'
import searchJob from './modules/searchJob'
import searchGroupingJob from './modules/searchGroupingJob'
import searchMap from './modules/searchMap'
import searchCondition from './modules/search-condition'
import jobList from './modules/job-list'
import jobMark from './modules/job-mark'
import jobTableConfiguration from './modules/job-table-configuration'
import csvFile from './modules/csv-file'
import client from './modules/client'
import searchJobList from './modules/searchJobList'
import startingBusiness from './modules/startingBusiness'
import searchStartingBusiness from './modules/searchStartingBusiness'
import startingBusinessList from './modules/startingBusinessList'
import searchStartingBusinessList from './modules/searchStartingBusinessList'
import exclusionCompanyName from './modules/exclusionCompanyName'
import inclusionCompanyName from './modules/inclusionCompanyName'
import aggregateJob from './modules/aggregateJob'
import guide from './modules/guide'
import aggJobSearchCondition from './modules/aggJobSearchCondition'
import jobNotificationSetting from './modules/jobNotificationSetting'
import news from './modules/news'
import uploadArchive from './modules/uploadArchive'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const storeConfiguration = {
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    account,
    aggregation,
    common,
    company,
    companyTableConfiguration,
    corporation,
    corporationTableConfiguration,
    route,
    session,
    user,
    job,
    map,
    master,
    searchAggregation,
    searchCompany,
    searchCorporation,
    searchJob,
    searchGroupingJob,
    searchMap,
    searchCondition,
    jobList,
    jobMark,
    jobTableConfiguration,
    csvFile,
    client,
    searchJobList,
    startingBusiness,
    searchStartingBusiness,
    startingBusinessList,
    searchStartingBusinessList,
    exclusionCompanyName,
    inclusionCompanyName,
    aggregateJob,
    guide,
    aggJobSearchCondition,
    jobNotificationSetting,
    news,
    uploadArchive,
  },
  strict: true,
  plugins: debug ? [createLogger()] : [],
}

export default function createStore (initialState) {
  storeConfiguration.modules.session.state.authenticated = initialState.authorized
  storeConfiguration.modules.master.state.loaded = initialState.masterLoaded
  storeConfiguration.modules.user.state.detail = initialState.currentUser
  Object.keys(initialState.masters).forEach((key) => {
    const variableName = camel(key)
    storeConfiguration.modules.master.state[variableName] = initialState.masters[key]
  })
  return new Vuex.Store(storeConfiguration)
}



// WEBPACK FOOTER //
// ./src/store/index.js